import { render, staticRenderFns } from "./vipDataCard.vue?vue&type=template&id=55c5ab69&scoped=true"
import script from "./vipDataCard.vue?vue&type=script&lang=js"
export * from "./vipDataCard.vue?vue&type=script&lang=js"
import style0 from "./vipDataCard.vue?vue&type=style&index=0&id=55c5ab69&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c5ab69",
  null
  
)

export default component.exports